import React, { Component } from 'react';
import { connect } from 'react-redux';

interface Props {
  foregroundColor: string;
}

class PageNavigatorStyle extends Component<Props> {
  render() {
    const { foregroundColor } = this.props;
    return (
      <style type="text/css" scoped>
        {`
          .navigator a,
          i.sx-icon.sx-left.sx-chevron-left {
            color: ${foregroundColor};
          }
          .survey .survey-navigator .next .navigation,
          .survey-submit {
            background-color: ${foregroundColor};
          }
          .survey .survey-navigator .next .navigation:focus,
          .survey .survey-navigator .prev .navigation:focus {
            box-shadow: 0 0 1px 6px ${foregroundColor}25;
          }
          .survey-prev:focus,
          .survey-next:focus,
          .survey-submit:focus {
            outline: none;
            box-shadow: 0 0 1px 6px ${foregroundColor}25;
          }
        `}
      </style>
    );
  }
}

const mapStateToProps = (state) => {
  const { customization } = state;
  return {
    foregroundColor: customization.foregroundColor,
  };
};

export default connect(mapStateToProps)(PageNavigatorStyle);
